<nz-alert *ngIf="!(emailVerified$ | async)" nzShowIcon nzType="warning" [nzDescription]="alertDescriptionTmpl">
    <ng-template #alertDescriptionTmpl>
        <div class="a-fx a-fx-between-center a-fx-gap-32">
            <div class="a-fx-col a-fx-gap-8 a-fx-flex">
                <div class="h3">
                    {{ 'common.email-verification.title' | translate }}
                </div>

                <div [innerHTML]="'common.email-verification.message' | translate"></div>
            </div>

            <button
                nz-button
                nzType="primary"
                class="a-fx-none"
                [nzLoading]="sending$ | async"
                (click)="resendEmailVerification()"
            >
                {{ 'common.email-verification.button' | translate }}
            </button>
        </div>
    </ng-template>
</nz-alert>
